import { BoxProps } from '@chakra-ui/core'

const rootStyleProps = [
  'm',
  'mt',
  'mr',
  'mb',
  'ml',
  'mx',
  'my',
  'margin',
  'marginTop',
  'marginBottom',
  'marginLeft',
  'marginRight',
  'marginY',
  'marginX',
  'flex',
  'flexBasis',
  'justifyContent',
  'width',
  'minWidth',
  'maxWidth',
  'maxW',
  'minW',
  'h',
  'height',
  'w',
  'width',
  'size',
  'zIndex',
  'top',
  'right',
  'bottom',
  'left',
  'position',
  'pos',
]

export function splitStyleProps(props: any) {
  const styleProps: any = {}
  const otherProps: any = {}

  if (!props || typeof props !== 'object') return [styleProps, otherProps]

  for (const key in props) {
    if (rootStyleProps.includes(key)) {
      styleProps[key] = props[key]
    } else {
      otherProps[key] = props[key]
    }
  }

  return [styleProps, otherProps]
}

export default splitStyleProps
